import L from "leaflet";
import { GestureHandling } from "leaflet-gesture-handling";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import Swiper, { Navigation, Pagination } from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);


function fixCoord(value) {
  let num = parseFloat(value);

  // Count integer digits
  const intPart = Math.floor(Math.abs(num)).toString().length;

  if (intPart > 2) {
    // Too many digits → divide until it's 2 digits
    while (Math.floor(Math.abs(num)).toString().length > 2) {
      num /= 10;
    }
  } else if (intPart < 2) {
    // Too few digits → multiply until it's 2 digits
    while (Math.floor(Math.abs(num)).toString().length < 2) {
      num *= 10;
    }
  }

  return num;
}
//init map
const map = () => {
  if (
    searchInitialize.search.destinations.locationType === 2 &&
    searchInitialize.hotel.longitude &&
    searchInitialize.hotel.latitude
  ) {
    let location = [
      fixCoord(searchInitialize.hotel.latitude),
      fixCoord(searchInitialize.hotel.longitude),
    ];

    var map = L.map("map", {
      gestureHandling: true,
      attributionControl: false,
    }).setView(location, 16);

    let icon = L.icon({
      iconSize: [24, 36],
      iconAnchor: [12, 36],
      iconUrl:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII=",
    });
    L.point(275, 170);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a rel="noopener noreferrer nofollow" target="_blank" href="https://openstreetmap.org/copyright" >OpenStreetMap</a> contributors',
    }).addTo(map);

    L.marker(location, { icon: icon }).addTo(map).openPopup();
  }
};
map();

//scroll to section with id because of react cant use anchor tags
window.scrollToSection = (id) => {
  $(`div#${id}`)[0]?.scrollIntoView();
};

const showMore = () => {
  $(".show-more").remove();
  $(".js-hotel-description").css("max-height", "initial");
};

//show more in description section
const addDescription = () => {
  let descriptionHeight = $(".js-hotel-description").prop("scrollHeight");
  if (descriptionHeight > 183) {
    let button = `<div class="show-more">
    <button class="js-show-more-btn">نمایش بیشتر <i class="icon-arrow-down"></i></button
    </div>`;
    $(".js-hotel-description").append(button);
    $(".js-show-more-btn").click(showMore);
  }
};
addDescription();

var previosTab = null;
window.activeTab = (e) => {
  if (previosTab != null)
    document
      .getElementsByClassName(`item-${previosTab}`)[0]
      .classList.remove("anchor-menu__item--active");
  document
    .getElementsByClassName(`item-${e}`)[0]
    .classList.add("anchor-menu__item--active");
  previosTab = e;
};

window.showMoreSearchBox = () => {
  $(".search-box__form").toggleClass("flex-show");
};

//init gallery(hotel images) slider
$(document).ready(function () {
  //init gallery slider in description
  hotelSlider();

  //init gallery in modal
  initModalSlider();

  //init slider in room-card
  var swiper = new Swiper(".mySwiper", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});

const hotelSlider = () => {
  new Swiper(".descriptionMySwiper2", {
    loop: true,
    navigation: {
      nextEl: ".description__swiper-button-next",
      prevEl: ".description__swiper-button-prev",
    },
  });
};

const initModalSlider = () => {
  var bigimage = $(".big1");

  bigimage.owlCarousel({
    rtl: true,
    items: 1,
    slideSpeed: 2000,
    nav: true,
    autoplay: false,
    dots: false,
    loop: true,
    navText: [
      '<i class="icon-arrow-right" aria-hidden="true"></i>',
      '<i class="icon-arrow-left" aria-hidden="true"></i>',
    ],
    responsive: false,
  });
};

//init hotel stars
$(".getRating").giveScore({
  TotalNum: 5,
  getScore: false,
  setScore: true,
  fontIcon: true,
  htmlelement: false,
  writeScore: false,
  getAndSet: false,
  iclasses: {
    unselect: "icon-star",
    select: "icon-star-yellow",
    halfIcon: "icon-star-half",
  },
});

//open room modal
$(".js-open-modal").click(function () {
  $(this).closest(".room-card").find(".js-room-modal").addClass("show-modal");
  $("html").addClass("no-scroll");
});

//close room modal
$(".js-room-modal").click(function (i) {
  if (
    $(i.target).hasClass("js-room-modal") ||
    $(i.target).hasClass("js-close-modal")
  ) {
    $(".js-room-modal").removeClass("show-modal");
    $("html").removeClass("no-scroll");
  }
});
